import axios from "axios";

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || (typeof window !== "undefined" ? window.location.origin : ""); // export separately

const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const getApiBaseUrl = () => {
  if (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1')
  ) {
    const envUrl = process.env.REACT_APP_API_URL;
    if (
      !envUrl ||
      envUrl.includes('localhost') ||
      envUrl.includes('127.0.0.1')
    ) {
      return 'http://localhost:8080/api';
    }
  }
  return process.env.REACT_APP_API_URL || (typeof window !== "undefined"
    ? `${window.location.origin}/api`
    : "/api");
};

const customInstance = axios.create({
  // Use the dynamic URL helper with fallback to localhost
  baseURL: getApiBaseUrl(),
  headers: { Accept: "application/json" },
  withCredentials: true,
});

// Intercept requests to add the Authorization token if available
customInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const csrfToken = getCookie("csrfToken");
    if (csrfToken) {
      config.headers["x-csrf-token"] = csrfToken;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Intercept responses to handle 401 Unauthorized errors globally
customInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const PERSISTED_STORAGE_KEYS = [
        'token',
        'refreshToken',
        'persist:user',
        'persist:imgurl',
        'persist:itemdata',
        'persist:auth',
        'MeAsmarketerId',
        'MeAsmarketerUserId',
        'MarketerFor'
      ];
      PERSISTED_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default customInstance;
